import { API_TYPE } from "../../utils/config";

export const GET_SEARCH_LOC = API_TYPE("GET_SEARCH_LOC");
export const GET_CURRENCY_LIST = API_TYPE("GET_CURRENCY_LIST"); // Move to LoginActiontype/ AuthActionType
export const GET_AGENTS_LIST = API_TYPE("GET_AGENTS_LIST"); // TW API
export const GET_AGENTS_USERS_LIST = API_TYPE("GET_AGENTS_USERS_LIST"); // TW API
export const GET_CURRENCIES_BY_AGENTID = API_TYPE("GET_CURRENCIES_BY_AGENTID"); // TW API
export const GET_AGENT_BY_ID = API_TYPE("GET_AGENT_BY_ID"); // TW API
export const GET_CURRENCY_CONVERSION_RATES = API_TYPE(
  "GET_CURRENCY_CONVERSION_RATES",
); // TW API
export const GET_ACTIVE_AGENTS_DETAILS = API_TYPE("GET_ACTIVE_AGENTS_DETAILS"); // TW API
export const GET_NATIONALITY_LIST = API_TYPE("GET_NATIONALITY_LIST");
export const GET_CITY_LIST = API_TYPE("GET_CITY_LIST");

export const GET_HOTEL_SEARCH = API_TYPE("GET_HOTEL_SEARCH");
export const SET_PRODUCT_SEARCH_TIME_EXPIRE = API_TYPE("SET_PRODUCT_SEARCH_TIME_EXPIRE");
export const RESET_GET_HOTEL_SEARCH = "RESET_GET_HOTEL_SEARCH";
export const GET_HOTELS_LIST = API_TYPE("GET_HOTELS_LIST");
export const RESET_GET_HOTELS_LIST = "RESET_GET_HOTELS_LIST";

export const GET_SEARCH_ADDRESSES = API_TYPE("GET_SEARCH_ADDRESSES");
export const RESET_GET_SEARCH_ADDRESSES = "RESET_GET_SEARCH_ADDRESSES";

export const GET_SEARCH_EXTRA_DETAILS = API_TYPE("GET_SEARCH_EXTRA_DETAILS");
export const RESET_GET_SEARCH_EXTRA_DETAILS = "RESET_GET_SEARCH_EXTRA_DETAILS";

export const GET_HOTEL_LEVEL_FILTER = API_TYPE("GET_HOTEL_LEVEL_FILTER");
export const RESET_GET_HOTEL_LEVEL_FILTER = "RESET_GET_HOTEL_LEVEL_FILTER";

export const GET_HOTEL_INFO = API_TYPE("GET_HOTEL_INFO");
export const GET_HOTEL_RATES = API_TYPE("GET_HOTEL_RATES");
export const GET_SIMILAR_HOTELS = {
  ...API_TYPE("GET_SIMILAR_HOTELS"),
  RESET: "GET_SIMILAR_HOTELS_RESET",
};
export const GET_HOTEL_RATES_MORE = API_TYPE("GET_HOTEL_RATES_MORE");
export const GET_ROOM_OPTIONS_RATES = API_TYPE("GET_ROOM_OPTIONS_RATES");
export const GET_ROOM_OPTIONS_RATES_MORE = API_TYPE(
  "GET_ROOM_OPTIONS_RATES_MORE",
);
export const RESET_HOTEL_DETAILS = "RESET_HOTEL_DETAILS";

export const GET_HOTEL_MULTIROOM_MEAN_RATE = API_TYPE(
  "GET_HOTEL_MULTIROOM_MEAN_RATE",
);

export const GET_AIRPORTS = API_TYPE("GET_AIRPORTS");
export const GET_DROP_AIRPORTS = API_TYPE("GET_DROP_AIRPORTS");
export const GET_AIRLINES = API_TYPE("GET_AIRLINES");
export const GET_ACCOMMODATION = API_TYPE("GET_ACCOMMODATION");
export const GET_DROP_ACCOMMODATION = API_TYPE("GET_DROP_ACCOMMODATION");

export const GET_ADD_USER_SEARCH_HISTORY = API_TYPE(
  "GET_ADD_USER_SEARCH_HISTORY",
);
export const GET_GET_USER_SEARCH_HISTORY = API_TYPE(
  "GET_GET_USER_SEARCH_HISTORY",
);
export const GET_DESTINATION = API_TYPE("GET_DESTINATION");
export const GET_DESTINATIONTO = API_TYPE("GET_DESTINATIONTO");
export const RESET_GET_DESTINATION = "RESET_GET_DESTINATION";
export const GET_DESTINATION_ACTIVITY = API_TYPE("GET_DESTINATION_ACTIVITY");
export const RESET_GET_DESTINATION_ACTIVITY = "RESET_GET_DESTINATION_ACTIVITY";
export const RESET_GET_AIRPORTS = "RESET_GET_AIRPORTS";
export const RESET_GET_DROP_AIRPORTS = "RESET_GET_DROP_AIRPORTS";
export const RESET_GET_ACCOMMODATION = "RESET_GET_ACCOMMODATION";
export const RESET_GET_DROP_ACCOMMODATION = "RESET_GET_DROP_ACCOMMODATION";

export const GET_AGENT_CREDIT_LIMIT = API_TYPE("GET_AGENT_CREDIT_LIMIT");
export const GET_MAIL_TEMPLATE = API_TYPE("GET_MAIL_TEMPLATE");
export const GET_BOOKINGDRAFT_BY_TWBID = API_TYPE("GET_BOOKINGDRAFT_BY_TWBID");
export const GET_GET_THRESHOLDLIMIT = API_TYPE("GET_GET_THRESHOLDLIMIT");
export const GET_ADD_MAIL_LOG = API_TYPE("GET_ADD_MAIL_LOG");
export const CONFIG_VALUE = API_TYPE("CONFIG_VALUE");
export const PAYMENT_GATEWAY_TRANSACTIONS = API_TYPE(
  "PAYMENT_GATEWAY_TRANSACTIONS",
);
export const GET_ADD_UPDATE_BOOKING_UPLOAD = API_TYPE(
  "GET_ADD_UPDATE_BOOKING_UPLOAD",
);
export const GET_ADD_UPDATE_BOOKING_DRAFT = API_TYPE(
  "GET_ADD_UPDATE_BOOKING_DRAFT",
);
export const BOOKINGDETAILS_BY_ITERNARYID = API_TYPE(
  "BOOKINGDETAILS_BY_ITERNARYID",
);
export const PREVIEW_URL = API_TYPE("PREVIEW_URL");
export const GET_ADD_AGENTQUOTE = API_TYPE("GET_ADD_AGENTQUOTE");
export const POST_PAYMENT_GATEWAY = API_TYPE("POST_PAYMENT_GATEWAY");
export const VALIDATE_PG_CURRENCY = API_TYPE("VALIDATE_PG_CURRENCY");
export const VALIDATE_PAYMENT_LINK = API_TYPE("VALIDATE_PAYMENT_LINK");

export const SET_DARK_THEME = "SET_DARK_THEME";

// these are used to know whether to call particular apis or not
export const SET_CALL_HOTEL_LIST_API = "SET_CALL_HOTEL_LIST_API";
export const SET_CALL_ADDRESSES_API = "SET_CALL_ADDRESSES_API";
export const SET_CALL_EXTRA_DETAILS_API = "SET_CALL_EXTRA_DETAILS_API";

// export const SEARCHKEY = 'SEARCHKEY';

export const GET_CALL_CANCELLATION_POLICY = API_TYPE(
  "GET_CALL_CANCELLATION_POLICY",
);

export const GET_ALL_CURRENT_SUPPLIERS = API_TYPE("GET_ALL_CURRENT_SUPPLIERS");
export const VALIDATE_DUPLICATE_BOOKING = API_TYPE(
  "VALIDATE_DUPLICATE_BOOKING",
);
export const AGENT_INVOICE_ACTIONTYPE = API_TYPE("AGENT_INVOICE_ACTIONTYPE");
export const AGENT_INFO_FINALIZE_TRANSFER = API_TYPE(
  "AGENT_INFO_FINALIZE_TRANSFER",
);
export const PRICE_CALCULATE_OC_PC = API_TYPE("PRICE_CALCULATE_OC_PC");
export const POST_PRICE_CALCULATE = API_TYPE("POST_PRICE_CALCULATE");
export const AGENTS_BY_CURRENCY = API_TYPE("AGENTS_BY_CURRENCY");
export const AGENTS_BY_CURRENCY_AND_INVOICEENTITY_ACTION_TYPE = API_TYPE(
  "AGENTS_BY_CURRENCY_AND_INVOICEENTITY_ACTION_TYPE",
);
export const BOOKINGS_LIST = API_TYPE("BOOKINGS_LIST");
export const ADD_TRANSFER_TO_AGENT = API_TYPE("ADD_TRANSFER_TO_AGENT");
export const ADD_FINALIZE_BOOKINGS = API_TYPE("ADD_FINALIZE_BOOKINGS");
export const GET_ACTIVITIES_CURRENT_SUPPLIERS = API_TYPE(
  "GET_ACTIVITIES_CURRENT_SUPPLIERS",
);
export const RESET_GET_ALL_CURRENT_SUPPLIERS =
  "RESET_GET_ALL_CURRENT_SUPPLIERS";

// Booking Process Action Types Starts here
export const GET_BOOKNOW_ID = API_TYPE("GET_BOOKNOW_ID");
export const GET_RECHECK_PRICE = API_TYPE("GET_RECHECK_PRICE");
export const GET_BOOKING_DETAILS = API_TYPE("GET_BOOKING_DETAILS");
export const GET_HOTEL_CHECKOUT_DETAILS = API_TYPE(
  "GET_HOTEL_CHECKOUT_DETAILS",
);
export const ADD_PG_TRANSACTION_DETAILS = API_TYPE(
  "ADD_PG_TRANSACTION_DETAILS",
);
export const GENERATE_HASH512_DETAILS = API_TYPE("GENERATE_HASH512_DETAILS");
export const GENERATE_FEATURED_HOTELS_DETAILS = API_TYPE(
  "GENERATE_FEATURED_HOTELS_DETAILS",
);
export const VALIDATE_PAN_DETAILS = API_TYPE("VALIDATE_PAN_DETAILS");
export const ACTIVITY_CANCELLATION_POLICY_DETAILS = API_TYPE(
  "ACTIVITY_CANCELLATION_POLICY_DETAILS",
);
export const TRANSFER_CANCELLATION_POLICY_DETAILS = API_TYPE(
  "TRANSFER_CANCELLATION_POLICY_DETAILS",
);
export const UPDATE_VALIDATION_STATUS_DETAILS = API_TYPE(
  "UPDATE_VALIDATION_STATUS_DETAILS",
);
export const ABANDON_REASONS_DETAILS = API_TYPE("ABANDON_REASONS_DETAILS");
export const BOOKABLE_THRESHOLD_DETAILS = API_TYPE(
  "BOOKABLE_THRESHOLD_DETAILS",
);
export const BOOKABLE_CL_DETAILS = API_TYPE("BOOKABLE_CL_DETAILS");
export const BOOKABLE_WB_DETAILS = API_TYPE("BOOKABLE_WB_DETAILS");
export const GET_AGENT_PROFILE_BY_AGENTID = API_TYPE(
  "GET_AGENT_PROFILE_BY_AGENTID",
);
export const AGENT_ALL_WIDGETS_DATA = API_TYPE("AGENT_ALL_WIDGETS_DATA");
// Booking Process Action Types Ends here
//SideBar Menu Selection
export const SET_SIDE_NAV_BAR_FOCUS = "SET_SIDE_NAV_BAR_FOCUS";
export const GET_BOOKING_DETAILS_BYBID = API_TYPE("GET_BOOKING_DETAILS_BYBID");
export const GET_DMC_LIST = API_TYPE("GET_DMC_LIST");
export const GET_DMC_CITIES_LIST = API_TYPE("GET_DMC_CITIES_LIST");
export const GET_DMC_TOURTYPES_LIST = API_TYPE("GET_DMC_TOURTYPES_LIST");
export const GET_DMC_PACKAGES_LIST = API_TYPE("GET_DMC_PACKAGES_LIST");
export const GET_DMC_PACKAGES_DETAILS_LIST = API_TYPE(
  "GET_DMC_PACKAGES_DETAILS_LIST",
);
export const SET_ZOHO_LAYOUT_RULES = API_TYPE("SET_ZOHO_LAYOUT_RULES");
export const SET_ZOHO_TICKET_CREATION = API_TYPE("SET_ZOHO_TICKET_CREATION");
export const SET_ZOHO_TICKET_DEPENDENCY_MAPPING = API_TYPE(
  "SET_ZOHO_TICKET_DEPENDENCY_MAPPING",
);
export const VOUCHER_VIEW_DETAILS = API_TYPE("VOUCHER_VIEW_DETAILS");
export const VOUCHER_VIEW_EURAIL_DETAILS = API_TYPE(
  "VOUCHER_VIEW_EURAIL_DETAILS",
);
export const VOUCHER_VIEW_TRANSFER_DETAILS = API_TYPE(
  "VOUCHER_VIEW_TRANSFER_DETAILS",
);
export const VOUCHER_VIEW_ACTIVITY_DETAILS = API_TYPE(
  "VOUCHER_VIEW_ACTIVITY_DETAILS",
);
export const BID_FROM_TEMP_ID = API_TYPE("BID_FROM_TEMP_ID");
export const UPDATE_PG_INVOICE_NUMBER = API_TYPE("UPDATE_PG_INVOICE_NUMBER");
export const ADD_BOOKING_MAIL_DATA = API_TYPE("ADD_BOOKING_MAIL_DATA");
export const GENERATE_LOGINURL_DETAILS = API_TYPE("GENERATE_LOGINURL_DETAILS");
export const CHECK_PAN_EXISTS_FOR_AGENT_DATA = API_TYPE(
  "CHECK_PAN_EXISTS_FOR_AGENT_DATA",
);
export const GRN_INVOICES_ACTIONTYPE = API_TYPE("GRN_INVOICES_ACTIONTYPE");
export const GRN_PROFORMAS_ACTIONTYPE = API_TYPE("GRN_PROFORMAS_ACTIONTYPE");
export const ITINERARY_ID_BY_TEMPID = API_TYPE("ITINERARY_ID_BY_TEMPID");
export const ADD_DUPLICATE_BOOKING_MAIL_DATA = API_TYPE(
  "ADD_DUPLICATE_BOOKING_MAIL_DATA",
);
export const FINALIZE_BOOKINGS_TRANSFER_ADMIN = API_TYPE(
  "FINALIZE_BOOKINGS_TRANSFER_ADMIN",
);
export const FINALIZED_BOOKINGS_TRANSFER_AGENT = API_TYPE(
  "FINALIZED_BOOKINGS_TRANSFER_AGENT",
);
export const ADD_TRANSFER_TO_AGENT_TRANSFER = API_TYPE(
  "ADD_TRANSFER_TO_AGENT_TRANSFER",
);
export const ACCESS_NOTIFICATIONS = API_TYPE("ACCESS_NOTIFICATIONS");
export const GET_HOTEL_INVOICE_ACTIONTYPE = API_TYPE(
  "GET_HOTEL_INVOICE_ACTIONTYPE",
);
export const GET_EURAIL_INVOICE_ACTIONTYPE = API_TYPE(
  "GET_EURAIL_INVOICE_ACTIONTYPE",
);
export const GET_ACTIVITY_INVOICE_ACTIONTYPE = API_TYPE(
  "GET_ACTIVITY_INVOICE_ACTIONTYPE",
);
export const GET_TRANSFERS_INVOICE_ACTIONTYPE = API_TYPE(
  "GET_TRANSFERS_INVOICE_ACTIONTYPE",
);
export const REQUEST_FAILURE_REASON_STATUS = API_TYPE(
  "REQUEST_FAILURE_REASON_STATUS",
);
export const SEND_VOUCHER_MAIL_ACTION_TYPE = API_TYPE(
  "SEND_VOUCHER_MAIL_ACTION_TYPE",
);
export const GENERATE_INVOICE_PDF_ACTIONTYPE = API_TYPE(
  "GENERATE_INVOICE_PDF_ACTIONTYPE",
);